import {Injectable} from '@angular/core';
import {ToastController} from '@ionic/angular';
import {ApiStatusEnum} from '../../../Shared/Enum/api-status.enum';
import {YuColorDto} from 'yukit';

@Injectable({
  providedIn: 'root'
})

export class ToastManagerService {

  private toast?: HTMLIonToastElement | null;

  constructor(private toastCtrl: ToastController) {
  }

  public showToastByStatusCode(status: number | string, header?: string, message?: string, duration?: number): void {
    if (status === 1 || status === ApiStatusEnum.success) {
      this.showSuccessToast(header, message, duration);
      return;
    }

    this.showWarningToast(header, message, duration);
  }

  public showInfoToast(header?: string, message?: string, duration?: number): void {
    this.showToast(header, message, 'info', 'alert-circle-outline', duration);
  }

  public showSuccessToast(header?: string, message?: string, duration?: number): void {
    this.showToast(header, message, 'success', 'checkmark-circle-outline', duration);
  }

  public showWarningToast(header?: string, message?: string, duration?: number): void {
    this.showToast(header, message, 'warning', 'alert-circle-outline', duration);
  }

  public showErrorToast(header?: string, message?: string, duration?: number): void {
    this.showToast(header, message, 'error', 'warning-outline', duration);
  }

  private async showToast(header?: string, message?: string, color?: YuColorDto, icon?: string, duration: number = 2000) {

    if (this.toast || duration <= 0) {
      return;
    }

    this.toast = await this.toastCtrl.create({
      header: header,
      message: message,
      duration: duration,
      icon: icon,
      position: 'top',
      cssClass: `yu-color-${color}`,
      buttons: [
        {
          text: '',
          icon: 'close',
          role: 'cancel',
        }
      ]
    });

    this.toast.onDidDismiss().then(() => {
      this.toast = null;
    });

    await this.toast.present();
  }

}
